module.exports = "<div class=\"featureCard card\">\r\n    <div class=\"feature-card--container\">\r\n        <div class=\"feature-card--inner-container\">\r\n            <a ng-href=\"{{::card.LinkUrl}}\" ng-click=\"::clickTracker()\">\r\n                <img loading=\"lazy\" class=\"vertical-center\" ng-srcset=\"{{::card.ImageUrl}}\" alt=\"\" />\r\n            </a>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/feature-card/feature-card-template.html
 ** module id = 931
 ** module chunks = 1
 **/